import { configSymbol } from '../symbols';
export var Config = /*#__PURE__*/function () {
  function Config(innerEngineConfig) {
    this[configSymbol] = void 0;
    this[configSymbol] = innerEngineConfig;
  }
  var _proto = Config.prototype;
  _proto.has = function has(key) {
    return this[configSymbol].has(key);
  };
  _proto.get = function get(key, defaultValue) {
    return this[configSymbol].get(key, defaultValue);
  };
  _proto.set = function set(key, value) {
    this[configSymbol].set(key, value);
  };
  _proto.setConfig = function setConfig(config) {
    this[configSymbol].setConfig(config);
  };
  _proto.onceGot = function onceGot(key) {
    return this[configSymbol].onceGot(key);
  };
  _proto.onGot = function onGot(key, fn) {
    return this[configSymbol].onGot(key, fn);
  };
  _proto.getPreference = function getPreference() {
    return this[configSymbol].getPreference();
  };
  return Config;
}();